import React, { useEffect, useState } from "react";
import { Checkbox, CircularAvatar, DropDown } from "../commons";
import { entityDropDown } from "../../constant/clientDirectoryDropDown";
import { preventEnterKey } from "../../utils/commonFunctions";
import { components } from "react-select";
import Select from "react-select";
import { DropDownType, UserProfileDetailErrorType } from "./SignUpCard";
import { BusinessInformationIcon, BusinessInformationRedIcon, CreateAccountIcon, PasswordSettingIcon, PasswordSettingRedIcon, PersonalInformationIcon, PersonalInformationRedIcon, ProjExelLogo } from "../../assets/images";

type AppProps = {
  onNext: (data: any) => void;
  onPrevious: (data:any) => void;
  setUserProfileDetailsError: React.Dispatch<React.SetStateAction<UserProfileDetailErrorType>>;
  userProfileDetailsError: UserProfileDetailErrorType;
  countrySelectedList: any;
  finalCountry: DropDownType;
  handleChangeCountry: (data: any) => void;
  handleChangeState: (data: any) => void;
  handleChangeCity: (data: any) => void;
  setText: React.Dispatch<React.SetStateAction<string>>;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  addressState: DropDownType;
  finalStateList: any;
  setStateText: React.Dispatch<React.SetStateAction<string>>;
  setStateOffset: React.Dispatch<React.SetStateAction<number>>;
  finalCityList: any;
  selectedCityList: DropDownType;
  setCityText: React.Dispatch<React.SetStateAction<string>>;
  setCityOffset: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  countryFetching: boolean;
  stateFetching: boolean;
  cityFetching: boolean;
  isState: null | boolean;
  isCity: null | boolean;
  setAddressState: React.Dispatch<React.SetStateAction<DropDownType>>;
  setCountry: React.Dispatch<React.SetStateAction<DropDownType>>;
  setSelectedCityList: React.Dispatch<React.SetStateAction<DropDownType>>;
  setTypeOfEntity: any;
  typeOfEntity:DropDownType;
  activeStep:number;

};
const BusinessDetailForm = ({
  onNext,
  onPrevious,
  setUserProfileDetailsError,
  userProfileDetailsError,
  countrySelectedList,
  finalCountry,
  handleChangeCountry,
  handleChangeState,
  handleChangeCity,
  setText,
  setOffset,
  addressState,
  finalStateList,
  setStateText,
  setStateOffset,
  finalCityList,
  selectedCityList,
  setCityText,
  setCityOffset,
  limit,
  countryFetching,
  stateFetching,
  cityFetching,
  isState,
  isCity,
  setAddressState,
  setCountry,
  setSelectedCityList,
  setTypeOfEntity,
  typeOfEntity,
  activeStep
}: AppProps) => {
  const { pathname } = window.location;
  const [businessName, setBusinessName] = useState("");
  const [noOfEmployee, setNoOfEmployee] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [haveGstRegistration, setHaveGstRegistration] = useState(false);
  const [loadCondition, setLoadCondition] = useState(true);

  useEffect(() => {
    let persistedData: any = localStorage.getItem("businessDetail");
    if (persistedData) {
      let parsedData = JSON.parse(persistedData);
      setBusinessName(parsedData?.businessName || "");
      setNoOfEmployee(parsedData?.noOfEmployee || "");
      setAddressState({
        value: parsedData?.value,
        label: parsedData?.label,
      });
      setCountry({
        value: parsedData?.value,
        label: parsedData?.label,
      });
      setSelectedCityList({
        value: parsedData?.value,
        label: parsedData?.label,
      });
      setTypeOfEntity({
        value: parsedData?.value,
        label: parsedData?.label,
      });
      setBusinessAddress(parsedData?.businessAddress || "");
      setHaveGstRegistration(parsedData?.haveGstRegistration || "");
    }
    setAddressState({
      value: "",
      label: "Select..",
    });
    setCountry({
      value: "",
      label: "Select..",
    });
    setSelectedCityList({
      value: "",
      label: "Select..",
    });
  }, []);

  const handleGstRegistrationBox = () => {
    setHaveGstRegistration(!haveGstRegistration);
  };
  const handleNext = (e: any) => {
    e.preventDefault();
    const data = {
      businessName,
      businessAddress,
      noOfEmployee,
      typeOfEntity,
      haveGstRegistration,
      addressState,
      finalCountry,
      selectedCityList
    };
    localStorage.setItem("businessDetail", JSON.stringify(data)); // Persist data

    onNext({
      businessName,
      businessAddress,
      noOfEmployee,
      typeOfEntity,
      haveGstRegistration,
      addressState,
      finalCountry,
      selectedCityList
    });
  };
  const handlePrevious=()=>{
    const data = {
      businessName,
      businessAddress,
      noOfEmployee,
      typeOfEntity,
      haveGstRegistration,
      addressState,
      finalCountry,
      selectedCityList
    };
    localStorage.setItem("businessDetail", JSON.stringify(data)); // Persist data
    onPrevious({ businessName,
      businessAddress,
      noOfEmployee,
      typeOfEntity,
      haveGstRegistration,
      addressState,
      finalCountry,
      selectedCityList})
  }
  const handleEntityChange = (data: any) => {
    setTypeOfEntity({
      value: data?.value,
      label: data?.label,
    });
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv: any) => prv + limit);
  };
  const checkBottomState = (e: any) => {
    setLoadCondition(false);
    setStateOffset((prv: any) => prv + limit);
  };
  const checkBottomCity = (e: any) => {
    setLoadCondition(false);
    setCityOffset((prv: any) => prv + limit);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };


  const isNextButtonEnabled = () => {
    if (!businessName?.trim() || !businessAddress?.trim() || !finalCountry?.value) {
      return false;
    }

    if (isState && isCity) {
      return !!(addressState?.value && selectedCityList?.value);
    }

    if (isState === false && isCity === false) {
      return true;
    }

    if (isState === false && isCity === true) {
      return !!selectedCityList?.value;
    }

    if (isState === true && isCity === false) {
      return !!addressState?.value;
    }

    return false;
  };

 const steps = [
     {
       icon: CreateAccountIcon,
       redIcon: CreateAccountIcon,
     
     },
     {
       icon: PersonalInformationIcon,
       redIcon: PersonalInformationRedIcon,
     
     },
     {
       icon: BusinessInformationIcon,
       redIcon: BusinessInformationRedIcon,
     
     },
     {
       icon: PasswordSettingIcon,
       redIcon: PasswordSettingRedIcon,
    
     },
   ];
   const withoutAuSteps = [
       {
         icon: CreateAccountIcon,
         redIcon: CreateAccountIcon,
       },
   
       {
         icon: BusinessInformationIcon,
         redIcon: BusinessInformationRedIcon,
       },
       {
         icon: PasswordSettingIcon,
         redIcon: PasswordSettingRedIcon,
       },
     ];
     const stepsToDisplay = pathname === "/signup" ? withoutAuSteps : steps;

  return (
    <>
      <div
        className="main-signup"
      >
        <div className="business-info-container">

          <div className="logo-section mb-3 ">
          <img src={ProjExelLogo}  className="company-logo" alt="finac_logo"/>
          <div style={{display:'flex',marginBottom:'30px'}}>
          {stepsToDisplay?.map((step, index) => (
          < >
          
                        <div  key={index} className="step-indicator">
                          <span
                            className={`step${
                              activeStep === index ? "active" : ""
                            }`}
                          >
                            <img
                              src={
                                activeStep === index || activeStep > index
                                  ? step?.redIcon
                                  : step?.icon
                              }
                              alt={' Icon'}
                            />
                          </span>
                          <span className="line"></span>
                        </div>
                      
                      </>
                      
                    ))}
                    </div>
                    
                            </div>
       
          <h5 className="mt-4 right-panel-heading">Business Information</h5>
          <span className="right-panel-subHeading">
            Enter your details below to get started.
          </span>
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="foldername">
                  Business Name <span className="color-red">*</span>
                </label>
                <input
                  type={"text"}
                  className={"form-control mb-3"}
                  name="text"
                  value={businessName}
                  autoFocus
                  onChange={(e) => setBusinessName(e.target.value)}
                  maxLength={60}
                />
                <div className="row no-row">
                  <div className="col-md-6">
                    <label htmlFor="foldername">No of Employees</label>
                    <input
                      type={"text"}
                      className={"form-control mb-3"}
                      name="text"
                      value={noOfEmployee}
                      // autoFocus
                      onChange={(e) => setNoOfEmployee(e.target.value)}
                      maxLength={60}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="foldername">Type Of Entity</label>
                    <DropDown
                      options={entityDropDown}
                      value={typeOfEntity}
                      handleChange={handleEntityChange}
                    />
                  </div>
                </div>

                <label htmlFor="foldername">
                  Business Address<span className="color-red">*</span>
                </label>
                <input
                  type={"text"}
                  className={"form-control mb-3"}
                  name="text"
                  value={businessAddress}
                  // autoFocus
                  onChange={(e) => setBusinessAddress(e.target.value)}
                  maxLength={60}
                />

                <div className="row no-row">
                  <div className="col-md-6">
                    <form>
                      <div className="form-group">
                        <div>
                          <label htmlFor="Country">
                            Country <span className="color-red">*</span>
                          </label>
                          <Select
                            onMenuClose={onMenuClose}
                            isSearchable={true}
                            options={countrySelectedList}
                            isLoading={countryFetching}
                            value={finalCountry}
                            onMenuScrollToBottom={(e: any) => checkBottom(e)}
                            onChange={(e) => {
                              handleChangeCountry(e);
                              handleChangeState(null);
                              handleChangeCity(null);
                            }}
                            onInputChange={(e) => {
                              setLoadCondition(false);
                              setText(e);
                              setOffset(0);
                            }}
                          />
                        </div>
                        <small className="text-danger">
                          {userProfileDetailsError?.countryError}
                        </small>
                      </div>
                    </form>
                  </div>
                  {finalCountry?.value && isState && (
                    <div className="col-md-6">
                      <form>
                        <div className="form-group">
                          <div>
                            {isState && (
                              <label
                                htmlFor="State"
                                className={addressState ? "active" : ""}
                              >
                                State <span className="color-red">*</span>
                              </label>
                            )}
                            {isState && (
                              <Select
                                onMenuClose={onMenuClose}
                                isSearchable={true}
                                options={finalStateList}
                                placeholder="Select..."
                                isLoading={stateFetching}
                                value={
                                  addressState?.value
                                    ? addressState
                                    : { label: "Select..", value: null }
                                }
                                onMenuScrollToBottom={(e: any) =>
                                  checkBottomState(e)
                                }
                                onChange={(e) => {
                                  handleChangeState(e);
                                  handleChangeCity(null);
                                }}
                                onInputChange={(e) => {
                                  setLoadCondition(false);
                                  setStateText(e);
                                  setStateOffset(0);
                                }}
                              />
                            )}
                          </div>
                          <small className="text-danger">
                            {userProfileDetailsError?.stateError}
                          </small>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
                <div className="row no-row">
                  {((isState === true && addressState?.value && isCity) ||
                    (isState === false && finalCountry?.value && isCity)) && (
                    <div className="col-md-6">
                      <form>
                        <div className="form-group">
                          <div>
                            <label
                              htmlFor="City"
                            >
                              City <span className="color-red">*</span>
                            </label>

                            <Select
                              onMenuClose={onMenuClose}
                              isSearchable={true}
                              options={finalCityList}
                              isLoading={countryFetching}
                              value={
                                selectedCityList?.value
                                  ? selectedCityList
                                  : { label: "Select..", value: null }
                              }
                              onMenuScrollToBottom={(e: any) =>
                                checkBottomCity(e)
                              }
                              onChange={(e) => handleChangeCity(e)}
                              onInputChange={(e) => {
                                setLoadCondition(false);
                                setCityText(e);
                                setCityOffset(0);
                              }}
                            />
                          </div>
                          <small className="text-danger">
                            {userProfileDetailsError?.cityError}
                          </small>
                        </div>
                      </form>
                    </div>
                  )}
                </div>

                <div className="d-flex">
                  <span className="mt-1">
                    <Checkbox
                      checked={haveGstRegistration}
                      onPress={handleGstRegistrationBox}
                    />
                  </span>
                  <span className="ml-2" style={{ marginBottom: "20px" }}>
                    Do you have GST Registration?
                  </span>
                </div>
                <div style={{ marginBottom: "100px" }}>
                  {/* <div className="d-flex back-button-parent" >
                    <button
                      type="submit"
                      className="btn btn-outline back-button"
                    
                      onClick={handlePrevious}
                    >
                      Back
                    </button>
                  </div> */}
                  <div className="d-flex back-next-parent" >
                    <button
                      type="submit"
                      className="btn btn-primary back-next"
                     
                      disabled={!isNextButtonEnabled()}
                      onClick={(e) => handleNext(e)}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <p className="mobileCopyright copyRightBottom">
                &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
              </p>
        </div>
      </div>
    </>
  );
};

export default BusinessDetailForm;
